// services/PortalApiService.js
// API client for the company / facility portal (talks to /api/company with the company token)
import axios from 'axios';
import { toast } from 'react-toastify';
import { COMPANY_API_URL, FACILITY_LOGIN_URL } from './apiConfig';

const language = localStorage.getItem('admin_lang') || 'en';


const apiClient = axios.create({
  baseURL: COMPANY_API_URL,
  headers: {
    'Accept': 'application/json',
    'language': language,
  },
});

const PortalApiService = {
  async request({ method, url, data, headers = {} }) {
    const company = localStorage.getItem('company') ? JSON.parse(localStorage.getItem('company')) : null;

    const config = {
      method,
      url,
      headers: {
        ...headers,
        Authorization: company?.auth_token ? `Bearer ${company.auth_token}` : '',
      },
    };

    if (method === 'GET' && data) {
      config.params = data;
    } else if (data) {
      config.data = data;
    }

    try {
      return await apiClient(config);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          toast.error(data.message);
          localStorage.removeItem('company');
          window.location.href = FACILITY_LOGIN_URL;
        } else if (status === 500) {
          toast.error('An internal server error occurred.');
        } else {
          toast.error(data.message);
        }
      } else if (error.request) {
        toast.error('Network error: Please try again later.');
      } else {
        toast.error('An error occurred: ' + error.message);
      }
      throw error;
    }
  },
};

export default PortalApiService;
